import { module } from 'angular';
import { SafePromiseWrapper } from 'src/modules/core/utils/SafePromiseWrapper';

export const CORE_UTILS_MODULE = module('coreUtilsModule', [])
    .service(
        'safePromiseWrapper',
        SafePromiseWrapper,
    );
